// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"ChangeTransaction_backdrop__12sHC","modal":"ChangeTransaction_modal__15L6p"};